export default 'cubicBezier(0.4, 0, 0.2, 1)'
